import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Experience from './components/Experience';
import Hero from './components/Hero';
import { education, experiences, projects, skills } from './shared/data';
import AboutMe from './components/AboutMe';
import ContactSection from './components/ContactSection';
import Education from './components/Education';
import Projects from './components/Projects';
import Skills from './components/Skills';

export default function Portfolio() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className="min-h-screen bg-stone-100 dark:bg-[#0B0C0E] text-neutral-900 dark:text-neutral-100 transition-colors duration-200">
      <Navbar toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />

      <Hero
        name="Bugra Ozdilek"
        role="Senior Software Engineer"
        subtitle="5+ years building scalable enterprise apps across the full stack. Currently focused on payment integrations and salesforce automation with .NET and Angular."
      />

      <main className="max-w-3xl mx-auto px-6 sm:px-8 pb-24 space-y-20 sm:space-y-24">
        <div id="about">
          <AboutMe />
        </div>

        <Experience experiences={experiences} />

        <Projects projects={projects} />

        <div id="skills">
          <Skills skills={skills} />
        </div>

        <div id="education">
          <Education education={education} />
        </div>

        <div id="contact">
          <ContactSection />
        </div>
      </main>

      <footer className="border-t border-neutral-200 dark:border-neutral-800 py-8">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 flex items-center justify-between text-[11px] font-mono uppercase tracking-[0.14em] text-neutral-500 dark:text-neutral-500">
          <span>© {new Date().getFullYear()} Bugra Ozdilek</span>
          <span className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-status-online" />
            Build 2026.10.18 · All systems nominal
          </span>
        </div>
      </footer>
    </div>
  );
}
